import React, { Fragment, useState } from 'react';
import T from 'prop-types';
import cx from 'classnames';

import ShowMoreRow from './ShowMoreRow';
import { formatAndAbbreviate, formatRevenue } from '../utils/formatters';

const PER_PAGE = 5;

const COLUMNS = [
  {
    key: 'most_downloaded',
    header: 'Most Downloaded',
    format: (value) => formatAndAbbreviate(value),
  },
  {
    key: 'highest_grossing',
    header: '$ Highest Grossing',
    format: (value) => formatRevenue(value),
  },
  {
    key: 'most_new_apps',
    header: 'Most New Apps/Week',
    format: (value) => formatAndAbbreviate(value),
  },
];

const TopCategories = ({ data }) => {
  const [visibleCount, setVisibleCount] = useState(PER_PAGE);

  const total = data.most_downloaded.length;
  const visible = Math.min(visibleCount, total);
  const remaining = total - visible;
  const fullyExpanded = remaining <= 0;

  return (
    <div>
      <h3 className="text-sm m-b-xs text-xxs-center">Top Categories (Last Week)</h3>
      <div className="table-responsive">
        <table className="table table-hover">
          <thead>
            <tr>
              {COLUMNS.map(({ key, header }, j) => (
                <th
                  key={key}
                  className={cx('b-t b-r b-b text-xxs-left', { 'b-l': j === 0 })}
                  colSpan="3"
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: visible }, (_, i) => (
              <tr key={i} className={cx({ 'b-b b-r': fullyExpanded && i === total - 1 })}>
                {COLUMNS.map(({ key, format }, j) => {
                  const row = data[key][i];

                  return (
                    <Fragment key={key}>
                      <td
                        className={cx('text-xxs-right', { 'b-l': j === 0 })}
                        width="12"
                        style={{ paddingRight: 0 }}
                      >
                        {i + 1}
                      </td>
                      <td className="text-xxs-left">
                        <a href={row.path}>{row.name}</a>
                      </td>
                      <td className="b-r text-xxs-right">{format(row.value)}</td>
                    </Fragment>
                  );
                })}
              </tr>
            ))}
            {remaining > 0 && (
              <ShowMoreRow
                count={Math.min(PER_PAGE, remaining)}
                unit={remaining === 1 ? 'category' : 'categories'}
                onClick={() => setVisibleCount((count) => count + PER_PAGE)}
              />
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const categoryRowShape = T.arrayOf(
  T.shape({
    name: T.string,
    path: T.string,
    value: T.number,
  })
);

TopCategories.propTypes = {
  data: T.shape({
    most_downloaded: categoryRowShape,
    highest_grossing: categoryRowShape,
    most_new_apps: categoryRowShape,
  }).isRequired,
};

export default TopCategories;
